import cookies from 'js-cookie'
import axios from 'axios'

import {
  CART_ID_COOKIE_NAME,
  REGION_COOKIE_NAME
} from 'scripts/react-components/shared/constants/cookies'
import {
  CART_ID_HEADER_NAME,
  REGION_HEADER_NAME
} from 'scripts/react-components/shared/constants/headers'

import { api } from './api'
import { AddSocialSignUpResponse, SocialSignUp } from '../types'

export const checkFiscalId = async (
  fiscalId: string,
  redirect: string | null
) => {
  try {
    const headers: {
      'Redirect-URL'?: string
    } = {}

    if (redirect) {
      headers['Redirect-URL'] = redirect
    }

    const { data } = await api.get<{ data: any }>(
      `/signup/check-cpf/${fiscalId}`,
      { headers }
    )

    return data
  } catch (error) {
    if (axios.isAxiosError(error)) {
      throw error.response
    } else {
      throw error
    }
  }
}

export const addSocialSignUp = async (
  provider: string,
  payload: SocialSignUp
) => {
  const region = cookies.get(REGION_COOKIE_NAME)
  const cartId = cookies.get(CART_ID_COOKIE_NAME)

  try {
    const { data } = await api.post<AddSocialSignUpResponse>(
      `/signup/social/${provider}`,
      payload,
      {
        headers: {
          ...(cartId && { [CART_ID_HEADER_NAME]: cartId }),
          ...(region && { [REGION_HEADER_NAME]: region })
        }
      }
    )

    return data
  } catch (error) {
    if (axios.isAxiosError(error)) {
      throw error.response
    } else {
      throw error
    }
  }
}
